export default {
    searchByDepartment: 'Search by Department',
    search: 'Search',
    createNewDepartment: 'Create New Department',
    department: 'Department',
    description: 'Description',
    manager: 'Manager',
    managerContact: 'Manager’s Contact',
    contactNo: 'Contact No',
    totalStaff: 'Total Staff',
    action: 'Action',
    congratulation: 'Congratulation',
    deleteDepertment: 'Delete Depertment',
    wantToDelete: 'Are you sure you want to delete',
    departmentIsDeleted: 'Department is deleted'
}
